import BarChart from './BarChart';
import CircularProgress from './CircularProgress';

const NguonLuoiChart = ({ dashboard }) => {
  const data = dashboard.reduce(
    (acc, item) => {
      // eslint-disable-next-line no-unused-vars
      const [_, label, value] = item;
      if (label.includes('Công suất')) {
        acc.power = value;
      } else if (label.includes('Phase')) {
        acc.volts.push(item);
      }
      return acc;
    },
    {
      power: 0,
      volts: [],
    }
  );

  return (
    <div className="nguon-luoi-chart">
      <CircularProgress targetValue={data.power} />
      <BarChart data={data.volts} />
    </div>
  );
};

export default NguonLuoiChart;
